import { store } from "lib/store";
import { memberActionTypes } from "lib/store/member/reducer";
import client from "../client";

interface GetTransactionMemberHistoryGameSMPointRequest {
  start: number;
  limit: number;
  box: GetTransactionMemberHistorySMPointGameResponse[];
}

export interface GetTransactionMemberHistorySMPointGameResponse {
  ID?: number;
  CreatedAt?: Date;
  UpdatedAt?: Date;
  DisplayCreatedAt?: string;
  DisplayUpdatedAt?: string;
  AfterBetAmount?: number;
  Amount?: number;
  Games?: number;
  HashKey?: string;
  NameTH?: string;
  NameEN?: string;
  Symbol?: string;
  IPAddress?: string;
  VenderName?: string;
  Uncalculated?: boolean;
  StatusWinLost?: string;
  StatusWinLostColor?: string;
  IsSMPointAfterBet?: boolean;
}

export default function API(
  request: GetTransactionMemberHistoryGameSMPointRequest
): Promise<GetTransactionMemberHistorySMPointGameResponse> {
  return client
    .get(`members/get_transaction_member_history_game_byMember_sm_point`, {
      params: { start: request.start, limit: request.limit },
    })
    .then((response) => response.data)
    .then((json) => {
      store.dispatch({
        type: memberActionTypes.ACTION_USER_UPDATE_TRANSACTION_UDIAMOND,
        payload: [...request.box, ...json],
      });
      return json;
    });
}
